import { useContext } from "react";
import { AuthContext } from "../../context/authContext";
import { Navigate } from "react-router-dom";
import { PATH_INFO } from "../util/helper";
import { Spin } from "antd";

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useContext(AuthContext)

  if (isAuthenticated === undefined) {
    return <Spin size="large" tip="Loading...">{children}</Spin>
  }

  if (!isAuthenticated) {
    return <Navigate to={PATH_INFO.LOGIN.PATH} replace />
  }

  return <>{children}</>
}